//设置REM
export const setFontSize = (doc, win) => {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      // 移动端开发，根据设计稿修改参数
      if (clientWidth > 750) {
        docEl.style.fontSize = 25.875 + 'px';
      } else {
        docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
}


//定义全局变量
export const installVar = (Vue, options) => {
  Vue.prototype.baseUrl = function () {
    return process.env.NODE_ENV === 'production' ?
      config.build.assetsPublicPath : config.dev.assetsPublicPath
  };
  Vue.prototype.sdplusPath = function () {
    return 'https://shundeplus.shundecity.com/index.php/'
  };
}

// 定义全局宽高
export const globalWH = (Vue, options) => {
  Vue.prototype.clientW = () => {
    return document.documentElement.clientWidth > 414 ? 414 : document.documentElement.clientWidth;
  }
  Vue.prototype.clientH = () => {
    return document.documentElement.clientWidth > 414? 730 : document.documentElement.clientHeight;
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js